import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import New from '@/components/New'
import NewDetails from '@/components/NewDetails'
import Rules from '@/components/Rules'
import Match from '@/components/Match'
import VideoList from '@/components/videoList'
import video from '@/components/video'
import Live from '@/components/Live'

Vue.use(Router)

export default new Router({
  mode:"history",
  routes: [
    {path: '/home', name: 'Home', component: Home},
    {path: '/news', name: 'New', component: New},
    {path: '/newDetails', name: 'NewDetails', component: NewDetails},
    {path: '/rules', name: 'Rules', component: Rules},
    {path: '/match', name: 'Match', component: Match},
    {path: '/videoList', name: 'VideoList', component: VideoList},
    {path: '/video', name: 'video', component: video},
    {path: '/live', name: 'Live', component: Live},




    { path: '/', redirect: '/home' },
    { path: '/*', redirect: '/home' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js